import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$3 = ".CodeContainer_module_container__1b0ae913{background:var(--st-accent);padding:var(--st-spacing-2) var(--st-spacing-4)}";
collectCss(css$3);
var modules_51b5745b = {"container":"CodeContainer_module_container__1b0ae913"};

export { css$3 as css, modules_51b5745b as default };
//# sourceMappingURL=CodeContainer.module.css.mjs.map
